import React from "react";
import { ContentLayout, Header, SpaceBetween, Alert } from "@cloudscape-design/components";
import { RedriveConfigForm, RedriveResults } from "../Components";
import { ApiClient, RedriveService } from "../services";
import { useRedrive } from "../hooks";
import { Stage, REDRIVE_LABELS, NotifyFn } from "../constants";

interface RedrivePageProps {
  stage: Stage;
  onNotify: NotifyFn;
}

const service = new RedriveService(ApiClient.getInstance());

export const RedrivePage: React.FC<RedrivePageProps> = ({ stage, onNotify }) => {
  const { config, setConfig, loading, polling, pollResult, handleRedrive, handleCancel } = useRedrive({
    onNotify,
    startRedriveFn: (realm, params) => service.startBatchRedrive(realm, params),
    pollRedriveFn: (realm, arn, logGroup, logStream) => service.pollBatchRedrive(realm, arn, logGroup, logStream),
    buildArnFn: (realm, name) => service.buildStateMachineArn(realm, name),
  });

  return (
    <ContentLayout
      header={
        <Header variant="h1" description={REDRIVE_LABELS.PAGE_DESCRIPTION}>
          {REDRIVE_LABELS.PAGE_TITLE}
        </Header>
      }
    >
      <SpaceBetween size="l">
        {stage === "prod" && (
          <Alert type="warning" header={REDRIVE_LABELS.PROD_WARNING_HEADER}>
            {REDRIVE_LABELS.PROD_WARNING_MESSAGE}
          </Alert>
        )}
        <RedriveConfigForm config={config} stage={stage} loading={loading} onConfigChange={setConfig} onSubmit={handleRedrive} />
        {(loading || pollResult) && <RedriveResults pollResult={pollResult} polling={polling} onCancel={handleCancel} />}
      </SpaceBetween>
    </ContentLayout>
  );
};
